import type { Injection } from '../../../types/utils';
import type { TableInjection } from './Table.types';

export const TABLE_INJECTION: Injection<TableInjection> = Object.freeze({
  key: Symbol('TABLE_INJECTION_KEY'),
});
